// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__+nyr5","loader__content":"Loader_loader__content__Luk7h","spin":"Loader_spin__8eadL"};